import React from 'react';

export default class MenuContacts extends React.PureComponent {
  
  render() {
    return (
      <div>
        <div> { this.props.isNeedTest} </div>
         {/*this.props.isNeedTest  && <a href="#" onClick={(e) => {e.preventDefault(); this.props.onTest();}}><i className="material-icons">psychology_alt</i></a>*/}
         <a href="#" onClick={(e) => {e.preventDefault(); this.props.onNewTalk();}}><i className="material-icons">forum</i></a>
         &nbsp;
        <a href="#" onClick={(e) => {e.preventDefault(); this.props.onNewTopic();}}><i className="material-icons">person_search</i></a>
        &nbsp;
        <a href="#" onClick={(e) => {e.preventDefault(); this.props.onSettings();}}><i className="material-icons">settings</i></a>
      </div>
    );
  }
};
